var _circle, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "#FDD64C",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0186 23.2647V15.976C16.0186 15.6891 16.1046 15.4093 16.2625 15.1726L18.2209 12.26C18.5294 11.7936 19.297 11.4636 19.9499 11.7076C20.6529 11.9443 21.1192 12.7334 20.9686 13.4365L20.5955 15.7823C20.5668 15.9976 20.6242 16.1913 20.7462 16.3419C20.8681 16.4782 21.0475 16.5643 21.2412 16.5643H24.1896C24.7564 16.5643 25.2442 16.7939 25.5312 17.1956C25.8038 17.583 25.854 18.0852 25.6746 18.5945L23.9099 23.9678C23.6875 24.8573 22.719 25.5819 21.7577 25.5819H18.9599C18.4792 25.5819 17.8049 25.4169 17.4964 25.1084L16.5781 24.3982C16.2266 24.1328 16.0186 23.7095 16.0186 23.2647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7374 14.5762H12.9985C11.8865 14.5762 11.4346 15.0066 11.4346 16.0683V23.2853C11.4346 24.347 11.8865 24.7775 12.9985 24.7775H13.7374C14.8494 24.7775 15.3013 24.347 15.3013 23.2853V16.0683C15.3013 15.0066 14.8494 14.5762 13.7374 14.5762Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 24.0479V16.7592C16.8008 16.4723 16.8869 16.1925 17.0447 15.9558L19.0032 13.0432C19.3117 12.5768 20.0793 12.2468 20.7321 12.4908C21.4351 12.7275 21.9014 13.5166 21.7508 14.2197L21.3777 16.5655C21.349 16.7808 21.4064 16.9745 21.5284 17.1251C21.6503 17.2614 21.8297 17.3475 22.0234 17.3475H24.9719C25.5386 17.3475 26.0264 17.5771 26.3134 17.9788C26.586 18.3662 26.6362 18.8684 26.4569 19.3777L24.6921 24.751C24.4697 25.6405 23.5012 26.3651 22.5399 26.3651H19.7421C19.2614 26.3651 18.5871 26.2001 18.2786 25.8916L17.3603 25.1814C17.0088 24.916 16.8008 24.4927 16.8008 24.0479Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5196 15.3594H13.7807C12.6688 15.3594 12.2168 15.7898 12.2168 16.8515V24.0685C12.2168 25.1302 12.6688 25.5607 13.7807 25.5607H14.5196C15.6316 25.5607 16.0835 25.1302 16.0835 24.0685V16.8515C16.0835 15.7898 15.6316 15.3594 14.5196 15.3594Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDislike);
export default __webpack_public_path__ + "static/media/activeDislike.cb9d06217c5ca076722483b421a1ed23.svg";
export { ForwardRef as ReactComponent };